import { AnimatePresence, motion } from "framer-motion";
import React, { useCallback, useEffect, useState } from "react";
import { FileMinus, Trash2 } from "react-feather";
import { getFileNameByFirebaseURL } from "../utils/utils";
import { IconButton } from "./IconButton";

interface FileSpaceProps {
  files?: File[] | string[];
  urls?: string[];
  handleDeleteFile?: (index: number, file: File | string) => void;
  disabled: boolean;
  imagen?: boolean;
}
export const FileSpace: React.FC<FileSpaceProps> = ({
  files,
  handleDeleteFile,
  imagen = false,
  urls,
  disabled,
}) => {
  return (
    <React.Fragment>
      <AnimatePresence>
        {files
          ? files.map((file: any, index) => {
              return (
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0 }}
                  className="flex flex-col justify-center items-center mr-4 mb-4"
                  key={`file-${index}`}
                >
                  {imagen ? (
                    <div className="h-32 w-40 rounded-lg bg-gray-300 overflow-hidden">
                      <ImageLoad file={file} />
                    </div>
                  ) : (
                    <div className="h-32 w-40 px-4 rounded-lg bg-gray-300 text-secondary flex flex-col items-center justify-center">
                      <FileMinus size={24} className="" />
                      {file?.name ? (
                        <span className="text-sm overflow-x-hidden overflow-ellipsis">
                          {file.name}
                        </span>
                      ) : (
                        <a href={file.URL} target={"_blank"}>
                          <span className="text-sm overflow-x-hidden overflow-ellipsis justify-center">
                            {getFileNameByFirebaseURL(file.URL)}
                          </span>
                        </a>
                      )}
                    </div>
                  )}
                  {!disabled && (
                    <IconButton onClick={() => handleDeleteFile!(index, file)}>
                      <Trash2
                        size={24}
                        className="text-secondary mt-4 cursor-pointer"
                      />
                    </IconButton>
                  )}
                </motion.div>
              );
            })
          : urls &&
            urls.map((url, index) => {
              return (
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0 }}
                  className="flex flex-col justify-center items-center mr-4 mb-4"
                  key={`file-${index}`}
                >
                  <div className="h-32 w-40 rounded-lg bg-gray-300 overflow-hidden">
                    <div
                      className="h-32 w-40 bg-contain bg-center"
                      style={{
                        backgroundImage: `url("${url}")`,
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                  </div>
                  <IconButton onClick={() => handleDeleteFile!(index, url)}>
                    <Trash2
                      size={24}
                      className="text-secondary mt-4 cursor-pointer"
                    />
                  </IconButton>
                </motion.div>
              );
            })}
      </AnimatePresence>
    </React.Fragment>
  );
};

interface ImageLoadProps {
  file: File;
}

const ImageLoad: React.FC<ImageLoadProps> = ({ file }) => {
  const [loading, setLoading] = useState(false);
  const [src, setSrc] = useState<any>();

  const loadImage = useCallback(async () => {
    setLoading(true);
    try {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        setSrc(reader.result);
      };
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [file]);

  useEffect(() => {
    loadImage();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      {!loading ? (
        <div
          className="h-32 w-40 bg-contain bg-center"
          style={{
            backgroundImage: `url("${src}")`,
            backgroundRepeat: "no-repeat",
          }}
        />
      ) : (
        <div></div>
      )}
    </div>
  );
};
